import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import SunburstModule from "highcharts/modules/sunburst";
import { height, width } from "@mui/system";
SunburstModule(Highcharts);
const isMobile = window.matchMedia("(max-width: 767px)").matches;


export const TeacherGraph2005 = ({ graphScmSchDataBrod, t, title }) => {
  console.log('graphScmSchDataBrod', graphScmSchDataBrod)
  const options = {
    colors: ["#E6694A", "#751539", "#F5BF55", "#cccc", "#1E88E5", "#43A047"], // Custom colors
    chart: {
      type: "column",
      marginTop: 50,
      events: {
        beforePrint: function () {
          this.exportSVGElements[0].box.hide();
          this.exportSVGElements[1].hide();
        },
        afterPrint: function () {
          this.exportSVGElements[0].box.show();
          this.exportSVGElements[1].show();
        },
      },
    },
    xAxis: {
      categories: graphScmSchDataBrod.categories,
    },
    // yAxis: {
    //   allowDecimals: false,
    //   min: 0,
    //   title: {
    //     text: "",
    //   },
    // },
    title: {
      text: title,
      style: {
        fontSize: "15px",
      },
    },
    tooltip: {
      headerFormat: "<b>{point.x}</b><br/>",
      pointFormat: "{series.name}: {point.y}",
      pointFormatter: function () {
        return `<span style="color:${this.color}">●</span> ${this.series.name}: <b>${this.y.toLocaleString("en-IN")}</b><br/>`;
      },
    },
    
     plotOptions: {
        column: {
            borderRadius: '25%'
        }
    },legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      itemMarginTop: 10,
      itemMarginBottom: 10,
    },
    credits: {
      enabled: false,
    },
    series: graphScmSchDataBrod.series,
    exporting: {
      filename: title,
      csv: {
        columnHeaderFormatter: function (item) {
          if (!item || item instanceof Highcharts.Axis) {
            return t("category");
          }
          return item.name;
        },
      },
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
};



export const TeacherPieGraphManagement = ({ teacherDataValueTypeBroad, t , title}) => {
    const options = {
        chart: {
          type: "pie",
          marginTop: 50,
          events: {
            beforePrint: function () {
              this.exportSVGElements[0].box.hide();
              this.exportSVGElements[1].hide();
            },
            afterPrint: function () {
              this.exportSVGElements[0].box.show();
              this.exportSVGElements[1].show();
            },
          },
        },
        title: {
          text: title,
        },
        tooltip: {
          pointFormat: "<b>{point.percentage:.2f}%</b>",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            size: "100%",
            dataLabels: {
              enabled: true,
              distance: 30,
              alignTo: isMobile ? "connectors" : null,
              connectorShape: "crookedLine",
              crookDistance: "100%",
              formatter: function () {
                return `<b>${this.point.percentage.toFixed(2)}%</b>`;
              },
              style: {
                fontSize: "16px",
                textOutline: "none",
                opacity: 0.7,
              },
            },
            center: ["50%", "50%"],
            showInLegend: true,
          },
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          itemMarginTop: 10,
          itemMarginBottom: 10,
        },
        series: [
          {
            name: t("percentage"),
            colorByPoint: true,
            data: [
              {
                name: "State Govt.",
                y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[0] + teacherDataValueTypeBroad?.series[1]?.data[0] + teacherDataValueTypeBroad?.series[2]?.data[0]),
                color: "#751539",
              },
              {
                name: "Govt. Aided",
                y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[1] + teacherDataValueTypeBroad?.series[1]?.data[1] + teacherDataValueTypeBroad?.series[2]?.data[1]),
                color: "#E6694A",
              },
              {
                name: "Private Unaided",
                y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[2] + teacherDataValueTypeBroad?.series[1]?.data[2] + teacherDataValueTypeBroad?.series[2]?.data[2]),
                color: "#F5BF55",
              },
              {
                name: "Central Govt.",
                y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[3] + teacherDataValueTypeBroad?.series[1]?.data[3] + teacherDataValueTypeBroad?.series[2]?.data[3]),
                color: "#BCE263",
              },
              {
                name: t("others"),
                y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[4] + teacherDataValueTypeBroad?.series[1]?.data[4] + teacherDataValueTypeBroad?.series[2]?.data[4]),
                color: "#57C1BB",
              },
            ],
          },
        ],
        exporting: {
          filename: title,
          csv: {
            columnHeaderFormatter: function (item) {
              if (!item || item instanceof Highcharts.Axis) {
                return t("category");
              }
              return item.name;
            },
          },
        },
      };

    return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
    
}


export const TeacherPieGraphManagement2010 = ({ teacherDataValueTypeBroad, t, title }) => {
  console.log('teacherDataValueTypeBroad', teacherDataValueTypeBroad)
    const options = {
        chart: {
          type: "pie",
          marginTop: 50,
          events: {
            beforePrint: function () {

              this.exportSVGElements[0].box.hide();
              this.exportSVGElements[1].hide();
            },
            afterPrint: function () {
              this.exportSVGElements[0].box.show();
              this.exportSVGElements[1].show();
            },
          },
        },
        title: {
          text: title,
        },
        tooltip: {
          pointFormat: "<b>{point.percentage:.2f}%</b>",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            size: "100%",
            dataLabels: {
              enabled: true,
              distance: 30,
              alignTo: isMobile ? "connectors" : null,
              connectorShape: "crookedLine",
              crookDistance: "100%",
              formatter: function () {
                return `<b>${this.point.percentage.toFixed(2)}%</b>`;
              },
              style: {
                fontSize: "16px",
                textOutline: "none",
                opacity: 0.7,
              },
            },
            center: ["50%", "50%"],
            showInLegend: true,
          },
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          itemMarginTop: 10,
          itemMarginBottom: 10,
        },
        series: [
          {
            name: t("percentage"),
            colorByPoint: true,
            data: [
              {
                name: "State Govt.",
                y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[0] + teacherDataValueTypeBroad?.series[1]?.data[0]),
                color: "#751539",
              },
              {
                name: "Govt. Aided",
                y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[1] + teacherDataValueTypeBroad?.series[1]?.data[1]),
                color: "#E6694A",
              },
              {
                name: "Private Unaided",
                y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[2] + teacherDataValueTypeBroad?.series[1]?.data[2]),
                color: "#F5BF55",
              },
              {
                name: "Central Govt.",
                y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[3] + teacherDataValueTypeBroad?.series[1]?.data[3]),
                color: "#BCE263",
              },
              {
                name: t("others"),
                y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[4] + teacherDataValueTypeBroad?.series[1]?.data[4]),
                color: "#57C1BB",
              },
            ],
          },
        ],
        exporting: {
          filename: title,
          csv: {
            columnHeaderFormatter: function (item) {
              if (!item || item instanceof Highcharts.Axis) {
                return t("category");
              }
              return item.name;
            },
          },
        },
      };

    return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
    
}

export const TeacherPieGraphManagement20101 = ({ teacherDataValueTypeBroad, t, title }) => {
  console.log('teacherDataValueTypeBroad', teacherDataValueTypeBroad)

  const data = [{
    id: '0.0',
    parent: '',
    name: ' '
}, {
    id: '1.3',
    parent: '0.0',
    name: 'Private Unaided',
}, {
    id: '1.1',
    parent: '0.0',
    name: 'State Govt.',
}, {
    id: '1.2',
    parent: '0.0',
    name: 'Govt. Aided',
}, {
    id: '1.4',
    parent: '0.0',
    name: 'Central Govt.',
}, {
    id: '1.5',
    parent: '0.0',
    name: 'others',
}, {
  id: '2.1',
  parent: '1.1',
  name: 'Regular',
  value:teacherDataValueTypeBroad?.series[0]?.data[0]
}, {
  id: '2.2',
  parent: '1.1',
  name: 'Non Regular',
  value:teacherDataValueTypeBroad?.series[1]?.data[0]
}, {
  id: '2.3',
  parent: '1.2',
  name: 'Regular',
  value:teacherDataValueTypeBroad?.series[0]?.data[1]
}, {
  id: '2.4',
  parent: '1.2',
  name: 'Non Regular',
  value:teacherDataValueTypeBroad?.series[1]?.data[1]
}, {
  id: '2.5',
  parent: '1.3',
  name: 'Regular',
  value:teacherDataValueTypeBroad?.series[0]?.data[2]
}, {
  id: '2.6',
  parent: '1.3',
  name: 'Non Regular',
  value:teacherDataValueTypeBroad?.series[1]?.data[2]
}, {
  id: '2.7',
  parent: '1.4',
  name: 'Regular',
  value:teacherDataValueTypeBroad?.series[0]?.data[3]
}, {
  id: '2.8',
  parent: '1.4',
  name: 'Non Regular',
  value:teacherDataValueTypeBroad?.series[1]?.data[3]
}, {
  id: '2.9',
  parent: '1.5',
  name: 'Regular',
  value:teacherDataValueTypeBroad?.series[0]?.data[4]
}, {
  id: '2.10',
  parent: '1.5',
  name: 'Non Regular',
  value:teacherDataValueTypeBroad?.series[1]?.data[4]
}
]


const totalPopulation = data.reduce((sum, point) => sum + (point.value || 0), 0); // Calculate total

const processedData = data.map(point => ({
    ...point,
    percentage: (point.value / totalPopulation) * 100 // Calculate percentage
}));

    const options = {
      chart: {
        // height: '100%'
height:400,
width:550
    },

    // Let the center circle be transparent
    colors: ['transparent'].concat(Highcharts.getOptions().colors),

    title: {
        text: title
    },
    credits: {
      enabled: false  // Disable Highcharts credits
  },
    subtitle: {
        // text: 'Source <a href="https://en.wikipedia.org/wiki/List_of_countries_by_population_(United_Nations)">Wikipedia</a>'
    },
    legend: {
      enabled: true,  // Ensure the legend is visible
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      itemStyle: {
          fontSize: '12px'  // Adjust font size for better visibility
      }
  },
    series: [{
        type: 'sunburst',
        data: processedData,
        name: 'Root',
        allowTraversingTree: true,
        borderRadius: 3,
        cursor: 'pointer',
        dataLabels: {
          formatter: function () {
            return this.point.percentage > 0 ? 
                `${this.point.name}: ${this.point.percentage.toFixed(1)}%` : `${this.point.name}`; // ✅ Hide if percentage is 0
        },
            filter: {
                property: 'innerArcLength',
                operator: '>',
                value: 16
            }
        },
        levels: [{
            level: 1,
            levelIsConstant: false,
            dataLabels: {
                filter: {
                    property: 'outerArcLength',
                    operator: '>',
                    value: 64
                }
            }
        }, {
            level: 2,
            colorByPoint: true
        },
        {
            level: 3,
            colorVariation: {
                key: 'brightness',
                to: -0.5
            }
        }, {
            level: 4,
            colorVariation: {
                key: 'brightness',
                to: 0.5
            }
        }]

    }],

    tooltip: {
        headerFormat: '',
        formatter: function () {
          if (this.point.percentage > 0) {
            return `The Nature of Appointment <b>${this.point.name}</b> is <b>${this.point.percentage.toFixed(1)}%</b>`;
        }
        return '';
      }
    }
      };
    return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
    
}



export const TeacherPieGraphManagement2011 = ({ teacherDataValueTypeBroad, t, title }) => {
  console.log('teacherDataValueTypeBroad', teacherDataValueTypeBroad)
    const options = {
        chart: {
          type: "pie",
          marginTop: 50,
          events: {
            beforePrint: function () {

              this.exportSVGElements[0].box.hide();
              this.exportSVGElements[1].hide();
            },
            afterPrint: function () {
              this.exportSVGElements[0].box.show();
              this.exportSVGElements[1].show();
            },
          },
        },
        title: {
          text: title,
        },
        tooltip: {
          pointFormat: "<b>{point.percentage:.2f}%</b>",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            size: "100%",
            dataLabels: {
              enabled: true,
              distance: 30,
              alignTo: isMobile ? "connectors" : null,
              connectorShape: "crookedLine",
              crookDistance: "100%",
              formatter: function () {
                return `<b>${this.point.percentage.toFixed(2)}%</b>`;
              },
              style: {
                fontSize: "16px",
                textOutline: "none",
                opacity: 0.7,
              },
            },
            center: ["50%", "50%"],
            showInLegend: true,
          },
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          itemMarginTop: 10,
          itemMarginBottom: 10,
        },
        series: [
          {
            name: t("percentage"),
            colorByPoint: true,
            data: [
              {
                name: "State Govt.",
                y: parseFloat(teacherDataValueTypeBroad?.series[2]?.data[0]),
                color: "#751539",
              },
              {
                name: "Govt. Aided",
                y: parseFloat(teacherDataValueTypeBroad?.series[2]?.data[1]),
                color: "#E6694A",
              },
              {
                name: "Private Unaided",
                y: parseFloat(teacherDataValueTypeBroad?.series[2]?.data[2]),
                color: "#F5BF55",
              },
              {
                name: "Central Govt.",
                y: parseFloat(teacherDataValueTypeBroad?.series[2]?.data[3]),
                color: "#BCE263",
              },
              {
                name: t("others"),
                y: parseFloat(teacherDataValueTypeBroad?.series[2]?.data[4]),
                color: "#57C1BB",
              },
            ],
          },
        ],
        exporting: {
          filename: title,
          csv: {
            columnHeaderFormatter: function (item) {
              if (!item || item instanceof Highcharts.Axis) {
                return t("category");
              }
              return item.name;
            },
          },
        },
      };

    return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
    
}





export const TeacherPieGraphCategory = ({ teacherDataValueTypeBroad, t, title }) => {

    const options = {
        chart: {
          type: "pie",
          marginTop: 50,
          events: {
            beforePrint: function () {
              this.exportSVGElements[0].box.hide();
              this.exportSVGElements[1].hide();
            },
            afterPrint: function () {
              this.exportSVGElements[0].box.show();
              this.exportSVGElements[1].show();
            },
          },
        },
        title: {
          text: title,
        },
        tooltip: {
          pointFormat: "<b>{point.percentage:.2f}%</b>",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            size: "100%",
            dataLabels: {
              enabled: true,
              distance: 30,
              alignTo: isMobile ? "connectors" : null,
              connectorShape: "crookedLine",
              crookDistance: "100%",
              formatter: function () {
                return `<b>${this.point.percentage.toFixed(2)}%</b>`;
              },
              style: {
                fontSize: "16px",
                textOutline: "none",
                opacity: 0.7,
              },
            },
            center: ["50%", "50%"],
            showInLegend: true,
          },
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          itemMarginTop: 10,
          itemMarginBottom: 10,
        },
        series: [
          {
            name: t("percentage"),
            colorByPoint: true,
            data: [
              {
                name: "Foundational and Preparatory",
                y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[0] + teacherDataValueTypeBroad?.series[0]?.data[1] + teacherDataValueTypeBroad?.series[0]?.data[2] + teacherDataValueTypeBroad?.series[0]?.data[3] + teacherDataValueTypeBroad?.series[0]?.data[4]),
                color: "#751539",
              },
              {
                name: "Middle",
                y: parseFloat(teacherDataValueTypeBroad?.series[1]?.data[0] + teacherDataValueTypeBroad?.series[1]?.data[1] + teacherDataValueTypeBroad?.series[1]?.data[2] + teacherDataValueTypeBroad?.series[1]?.data[3] + teacherDataValueTypeBroad?.series[1]?.data[4]),
                color: "#E6694A",
              },
              {
                name: "Secondary",
                y: parseFloat(teacherDataValueTypeBroad?.series[2]?.data[0] + teacherDataValueTypeBroad?.series[2]?.data[1] + teacherDataValueTypeBroad?.series[2]?.data[2] + teacherDataValueTypeBroad?.series[2]?.data[3] + teacherDataValueTypeBroad?.series[2]?.data[4]),
                color: "#F5BF55",
              },
             
            ],
          },
        ],
        exporting: {
          filename: title,
          csv: {
            columnHeaderFormatter: function (item) {
              if (!item || item instanceof Highcharts.Axis) {
                return t("category");
              }
              return item.name;
            },
          },
        },
      };

    return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
    
}


export const TeacherPieGraphManagement2009 = ({ graphScmSchDataBrod, t, title }) => {
  const options = {
      chart: {
        type: "pie",
        marginTop: 50,
        events: {
          beforePrint: function () {
            this.exportSVGElements[0].box.hide();
            this.exportSVGElements[1].hide();
          },
          afterPrint: function () {
            this.exportSVGElements[0].box.show();
            this.exportSVGElements[1].show();
          },
        },
      },
      title: {
        text: title,
      },
      tooltip: {
        pointFormat: "<b>{point.percentage:.2f}%</b>",
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          size: "100%",
          dataLabels: {
            enabled: true,
            distance: 30,
            alignTo: isMobile ? "connectors" : null,
            connectorShape: "crookedLine",
            crookDistance: "100%",
            formatter: function () {
              return `<b>${this.point.percentage.toFixed(2)}%</b>`;
            },
            style: {
              fontSize: "16px",
              textOutline: "none",
              opacity: 0.7,
            },
          },
          center: ["50%", "50%"],
          showInLegend: true,
        },
      },
      legend: {
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
        itemMarginTop: 10,
        itemMarginBottom: 10,
      },
      series: [
        {
          name: t("percentage"),
          colorByPoint: true,
          data:
          [
            {
              name: "State Government",
              y: parseFloat(graphScmSchDataBrod?.series[0]?.data[0] + graphScmSchDataBrod?.series[1]?.data[0] + graphScmSchDataBrod?.series[2]?.data[0] + graphScmSchDataBrod?.series[3]?.data[0]),
              color: "#751539",
            },
            {
              name: "Govt. Aided",
              y: parseFloat(graphScmSchDataBrod?.series[0]?.data[1] + graphScmSchDataBrod?.series[1]?.data[1] + graphScmSchDataBrod?.series[2]?.data[1] + graphScmSchDataBrod?.series[3]?.data[1]),
              color: "#E6694A",
            },
            {
              name: "Private Unaided",
              y: parseFloat(graphScmSchDataBrod?.series[0]?.data[2] + graphScmSchDataBrod?.series[1]?.data[2] + graphScmSchDataBrod?.series[2]?.data[2] + graphScmSchDataBrod?.series[3]?.data[2]),
              color: "#F5BF55",
            },
            {
              name: "Central Government",
              y: parseFloat(graphScmSchDataBrod?.series[0]?.data[3] + graphScmSchDataBrod?.series[1]?.data[3] + graphScmSchDataBrod?.series[2]?.data[3] + graphScmSchDataBrod?.series[3]?.data[3] ),
              color: "#BCE263",
            },
            {
              name: "Others",
              y: parseFloat(graphScmSchDataBrod?.series[0]?.data[4] + graphScmSchDataBrod?.series[1]?.data[4] + graphScmSchDataBrod?.series[2]?.data[4] + graphScmSchDataBrod?.series[3]?.data[4]),
              color: "#57C1BB",
            },
           
          ]
          ,
        },
      ],
      exporting: {
        filename: title,
        csv: {
          columnHeaderFormatter: function (item) {
            if (!item || item instanceof Highcharts.Axis) {
              return t("category");
            }
            return item.name;
          },
        },
      },
    };

  return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
  
}

export const TeacherPieGraphCategory2009 = ({ teacherDataValueTypeBroad, t, title }) => {

  const options = {
      chart: {
        type: "pie",
        marginTop: 50,
        events: {
          beforePrint: function () {
            this.exportSVGElements[0].box.hide();
            this.exportSVGElements[1].hide();
          },
          afterPrint: function () {
            this.exportSVGElements[0].box.show();
            this.exportSVGElements[1].show();
          },
        },
      },
      title: {
        text: title,
      },
      tooltip: {
        pointFormat: "<b>{point.percentage:.2f}%</b>",
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          size: "100%",
          dataLabels: {
            enabled: true,
            distance: 30,
            alignTo: isMobile ? "connectors" : null,
            connectorShape: "crookedLine",
            crookDistance: "100%",
            formatter: function () {
              return `<b>${this.point.percentage.toFixed(2)}%</b>`;
            },
            style: {
              fontSize: "16px",
              textOutline: "none",
              opacity: 0.7,
            },
          },
          center: ["50%", "50%"],
          showInLegend: true,
        },
      },
      legend: {
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
        itemMarginTop: 10,
        itemMarginBottom: 10,
      },
      series: [
        {
          name: t("percentage"),
          colorByPoint: true,
          data: [
            {
              name: "Foundational and Preparatory",
              y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[0] + teacherDataValueTypeBroad?.series[1]?.data[0] + teacherDataValueTypeBroad?.series[2]?.data[0] + teacherDataValueTypeBroad?.series[3]?.data[0]),
              color: "#751539",
            },
            {
              name: "Middle",
              y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[1] + teacherDataValueTypeBroad?.series[1]?.data[1] + teacherDataValueTypeBroad?.series[2]?.data[1] + teacherDataValueTypeBroad?.series[3]?.data[1]),
              color: "#E6694A",
            },
            {
              name: "Secondary",
              y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[2] + teacherDataValueTypeBroad?.series[1]?.data[2] + teacherDataValueTypeBroad?.series[2]?.data[2] + teacherDataValueTypeBroad?.series[3]?.data[2]),
              color: "#F5BF55",
            }
           
          ],
        },
      ],
      exporting: {
        filename: title,
        csv: {
          columnHeaderFormatter: function (item) {
            if (!item || item instanceof Highcharts.Axis) {
              return t("category");
            }
            return item.name;
          },
        },
      },
    };

  return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
  
}


export const TeacherPieGraphCategory2010 = ({ teacherDataValueTypeBroad, t, title }) => {
  console.log('teacherDataValueTypeBroad', teacherDataValueTypeBroad)

  const options = {
      chart: {
        type: "pie",
        marginTop: 50,
        events: {
          beforePrint: function () {
            this.exportSVGElements[0].box.hide();
            this.exportSVGElements[1].hide();
          },
          afterPrint: function () {
            this.exportSVGElements[0].box.show();
            this.exportSVGElements[1].show();
          },
        },
      },
      title: {
        text: title,
      },
      tooltip: {
        pointFormat: "<b>{point.percentage:.2f}%</b>",
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          size: "100%",
          dataLabels: {
            enabled: true,
            distance: 30,
            alignTo: isMobile ? "connectors" : null,
            connectorShape: "crookedLine",
            crookDistance: "100%",
            formatter: function () {
              return `<b>${this.point.percentage.toFixed(2)}%</b>`;
            },
            style: {
              fontSize: "16px",
              textOutline: "none",
              opacity: 0.7,
            },
          },
          center: ["50%", "50%"],
          showInLegend: true,
        },
      },
      legend: {
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
        itemMarginTop: 10,
        itemMarginBottom: 10,
      },
      series: [
        {
          name: t("percentage"),
          colorByPoint: true,
          data: [
            {
              name: "Foundational and Preparatory",
              y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[0] + teacherDataValueTypeBroad?.series[1]?.data[0]),
              color: "#751539",
            },
            {
              name: "Middle",
              y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[1] + teacherDataValueTypeBroad?.series[1]?.data[1]),
              color: "#E6694A",
            },
            {
              name: "Secondary",
              y: parseFloat(teacherDataValueTypeBroad?.series[0]?.data[2] + teacherDataValueTypeBroad?.series[1]?.data[2]),
              color: "#F5BF55",
            }
           
          ],
        },
      ],
      exporting: {
        filename: title,
        csv: {
          columnHeaderFormatter: function (item) {
            if (!item || item instanceof Highcharts.Axis) {
              return t("category");
            }
            return item.name;
          },
        },
      },
    };

  return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
  
}


export const TeacherPieGraphCategory20101 = ({ teacherDataValueTypeBroad, t, title }) => {
  console.log('teacherDataValueTypeBroad', teacherDataValueTypeBroad)

  const data = [{
    id: '0.0',
    parent: '',
    name: ' '
}, {
    id: '1.1',
    parent: '0.0',
    name: 'Foundational and Preparatory',
    // value:""
}, {
    id: '1.2',
    parent: '0.0',
    name: 'Middle',
    // value:""
}, {
    id: '1.3',
    parent: '0.0',
    name: 'Secondary',
    // value:""
},
 {
  id: '2.1',
  parent: '1.1',
  name: 'Regular',
  value:teacherDataValueTypeBroad?.series[0]?.data[0]
}, {
  id: '2.2',
  parent: '1.1',
  name: 'Non Regular',
  value:teacherDataValueTypeBroad?.series[1]?.data[0]
}, {
  id: '2.3',
  parent: '1.2',
  name: 'Regular',
  value:teacherDataValueTypeBroad?.series[0]?.data[1]
}, {
  id: '2.4',
  parent: '1.2',
  name: 'Non Regular',
  value:teacherDataValueTypeBroad?.series[1]?.data[1]
}, {
  id: '2.5',
  parent: '1.3',
  name: 'Regular',
  value:teacherDataValueTypeBroad?.series[0]?.data[2]
}, {
  id: '2.6',
  parent: '1.3',
  name: 'Non Regular',
  value:teacherDataValueTypeBroad?.series[1]?.data[2]
}
]


const totalPopulation = data.reduce((sum, point) => sum + (point.value || 0), 0); // Calculate total

const processedData = data.map(point => ({
    ...point,
    percentage: (point.value / totalPopulation) * 100 // Calculate percentage
}));

    const options = {
      chart: {
        // height: '100%'
height:400,
width:550
    },

    // Let the center circle be transparent
    colors: ['transparent'].concat(Highcharts.getOptions().colors),

    title: {
        text: title
    },
    credits: {
      enabled: false  // Disable Highcharts credits
  },
    subtitle: {
        // text: 'Source <a href="https://en.wikipedia.org/wiki/List_of_countries_by_population_(United_Nations)">Wikipedia</a>'
    },
    legend: {
      enabled: true,  // Ensure the legend is visible
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom',
      itemStyle: {
          fontSize: '12px'  // Adjust font size for better visibility
      }
  },
    series: [{
        type: 'sunburst',
        data: processedData,
        name: 'Root',
        allowTraversingTree: true,
        borderRadius: 3,
        cursor: 'pointer',
        dataLabels: {
            // format: '{point.name}',
            formatter: function () {
              return this.point.percentage > 0 ? 
                  `${this.point.name}: ${this.point.percentage.toFixed(1)}%` : `${this.point.name}`; // ✅ Hide if percentage is 0
          },
            filter: {
                property: 'innerArcLength',
                operator: '>',
                value: 16
            }
        },
        levels: [{
            level: 1,
            levelIsConstant: false,
            dataLabels: {
                filter: {
                    property: 'outerArcLength',
                    operator: '>',
                    value: 64
                }
            }
        }, {
            level: 2,
            colorByPoint: true
        },
        {
            level: 3,
            colorVariation: {
                key: 'brightness',
                to: -0.5
            }
        }, {
            level: 4,
            colorVariation: {
                key: 'brightness',
                to: 0.5
            }
        }]

    }],

    tooltip: {
        headerFormat: '',
        formatter: function () {
          if (this.point.percentage > 0) {
            return `The Nature of Appointment <b>${this.point.name}</b> is <b>${this.point.percentage.toFixed(1)}%</b>`;
        }
        return '';
      }
    }
      };
    return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
    
}



export const TeacherGraph2011 = ({ graphScmSchDataBrod, t, title }) => {
  const options = {
    colors: ["#E6694A", "#751539", "#F5BF55", "#cccc"], // Custom colors
    chart: {
      type: "column",
      marginTop: 50,
      events: {
        beforePrint: function () {
          this.exportSVGElements[0].box.hide();
          this.exportSVGElements[1].hide();
        },
        afterPrint: function () {
          this.exportSVGElements[0].box.show();
          this.exportSVGElements[1].show();
        },
      },
    },
    xAxis: {
      categories: graphScmSchDataBrod.categories,
    },
    // yAxis: {
    //   allowDecimals: false,
    //   min: 0,
    //   title: {
    //     text: "",
    //   },
    // },
    title: {
      text: title,
      style: {
        fontSize: "15px",
      },
    },
    tooltip: {
      headerFormat: "<b>{point.x}</b><br/>",
      pointFormat: "{series.name}: {point.y}",
      pointFormatter: function () {
        return `<span style="color:${this.color}">●</span> ${this.series.name}: <b>${this.y.toLocaleString("en-IN")}</b><br/>`;
      },
    },
    
     plotOptions: {
        column: {
            borderRadius: '25%'
        }
    },legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      itemMarginTop: 10,
      itemMarginBottom: 10,
    },
    credits: {
      enabled: false,
    },
    series: graphScmSchDataBrod.series,
    exporting: {
      filename: title,
      csv: {
        columnHeaderFormatter: function (item) {
          if (!item || item instanceof Highcharts.Axis) {
            return t("category");
          }
          return item.name;
        },
      },
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
};

export const TeacherPieGraphManagementBroad2011 = ({ teacherDataValueTypeBroad, t, title }) => {
  console.log('teacherDataValueTypeBroad', teacherDataValueTypeBroad);

  const maleNumer = teacherDataValueTypeBroad?.series[0]?.data?.reduce(
    (previousValue, currentValue, index) => previousValue + currentValue, 
    0);

  const femaleNumer = teacherDataValueTypeBroad?.series[1]?.data?.reduce(
    (previousValue, currentValue, index) => previousValue + currentValue, 
    0);

    const options = {
        chart: {
          type: "pie",
          marginTop: 50,
          events: {
            beforePrint: function () {

              this.exportSVGElements[0].box.hide();
              this.exportSVGElements[1].hide();
            },
            afterPrint: function () {
              this.exportSVGElements[0].box.show();
              this.exportSVGElements[1].show();
            },
          },
        },
        title: {
          text: title,
        },
        tooltip: {
          pointFormat: "<b>{point.percentage:.2f}%</b>",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            size: "100%",
            dataLabels: {
              enabled: true,
              distance: 30,
              alignTo: isMobile ? "connectors" : null,
              connectorShape: "crookedLine",
              crookDistance: "100%",
              formatter: function () {
                return `<b>${this.point.percentage.toFixed(2)}%</b>`;
              },
              style: {
                fontSize: "16px",
                textOutline: "none",
                opacity: 0.7,
              },
            },
            center: ["50%", "50%"],
            showInLegend: true,
          },
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          itemMarginTop: 10,
          itemMarginBottom: 10,
        },
        series: [
          {
            name: t("percentage"),
            colorByPoint: true,
            data: [
              {
                name: "Male",
                y: parseFloat(maleNumer),
                color: "#751539",
              },
              {
                name: "Female",
                y: parseFloat(femaleNumer),
                color: "#E6694A",
              },
              // {
              //   name: "Private Unaided",
              //   y: parseFloat(teacherDataValueTypeBroad?.series[2]?.data[2]),
              //   color: "#F5BF55",
              // },
              // {
              //   name: "Central Govt.",
              //   y: parseFloat(teacherDataValueTypeBroad?.series[2]?.data[3]),
              //   color: "#BCE263",
              // },
              // {
              //   name: t("others"),
              //   y: parseFloat(teacherDataValueTypeBroad?.series[2]?.data[4]),
              //   color: "#57C1BB",
              // },
            ],
          },
        ],
        exporting: {
          filename: title,
          csv: {
            columnHeaderFormatter: function (item) {
              if (!item || item instanceof Highcharts.Axis) {
                return t("category");
              }
              return item.name;
            },
          },
        },
      };

    return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
    
}


export const Graph4007 = ({ graphScmSchDataBrod, t, title }) => {
  console.log('graphScmSchDataBrod', graphScmSchDataBrod)
  const options = {
    colors: [
      "#E6694A", "#751539", "#F5BF55", "#CCCCCC", "#1E88E5", "#43A047", 
      "#8E44AD", "#FFC107", "#FF5722", "#607D8B", "#D81B60", "#00BCD4", 
      "#4CAF50", "#9C27B0", "#FFEB3B", "#795548", "#03A9F4", "#E91E63", 
      "#CDDC39", "#673AB7"
    ],
    chart: {
      type: "column",
      width:1200,
      height: 700,
      marginTop: 50,
      events: {
        beforePrint: function () {
          this.exportSVGElements[0].box.hide();
          this.exportSVGElements[1].hide();
        },
        afterPrint: function () {
          this.exportSVGElements[0].box.show();
          this.exportSVGElements[1].show();
        },
      },
    },
    xAxis: {
      categories: graphScmSchDataBrod.categories,
    },
    // yAxis: {
    //   allowDecimals: false,
    //   min: 0,
    //   title: {
    //     text: "",
    //   },
    // },
    title: {
      text: title,
      style: {
        fontSize: "15px",
      },
    },
    tooltip: {
      headerFormat: "<b>{point.x}</b><br/>",
      pointFormat: "{series.name}: {point.y}",
      pointFormatter: function () {
        return `<span style="color:${this.color}">●</span> ${this.series.name}: <b>${this.y.toLocaleString("en-IN")}</b><br/>`;
      },
    },
    
     plotOptions: {
        column: {
            borderRadius: '25%',
            pointWidth: 10, // Adjust this value to increase column width
            groupPadding: 0, // Reduce this value to decrease spacing between columns
        }
    },legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      itemMarginTop: 10,
      itemMarginBottom: 10,
    },
    credits: {
      enabled: false,
    },
    series: graphScmSchDataBrod.series,
    exporting: {
      filename: title,
      csv: {
        columnHeaderFormatter: function (item) {
          if (!item || item instanceof Highcharts.Axis) {
            return t("category");
          }
          return item.name;
        },
      },
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} immutable={true} />;
};


export const BarChart = ({data}) => {
  // const data = { a: 10, b: 20, c: 50, d: 10 };
  const graphData = data
  console.log('graphData', graphData)

  const keyMappings = {
    priT: "Foundational",
    upriT: "Preparatory",
    secT: "Middle",
    hsecT: "Secondary",
  };


    // Extract and transform data
    const categories = Object.keys(keyMappings); // ['priT', 'upriT', 'secT', 'hsecT']
    const values = categories.map((key) => parseFloat(graphData[0][key])); // Convert to number


  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Education Level",
    },
    xAxis: {
      categories: categories.map((key) => keyMappings[key]),
      title: {
        text: "Fields",
      },
    },
    yAxis: {
      title: {
        text: "Values",
      },
    },
    series: [
      {
        name: "Values",
        data: values,
        dataLabels: {
          enabled: true, // Show numbers on top of bars
          style: {
            fontWeight: "bold",
            fontSize: "12px",
            color: "#000", // Set text color
          },
        },
      },
    ],
    exporting: {
      filename: "Gender Parity index of GER by Level of Education",
      csv: {
        columnHeaderFormatter: function (item) {
          if (!item || item instanceof Highcharts.Axis) {
            return "Category";
          }
          return item.name;
        },
      },
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true, // Ensure labels are enabled for bars
        },
      },
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

